import Echo from 'laravel-echo';
import { getAppConfig } from 'larasnap/core';
import 'pusher-js';

const { key, cluster } = getAppConfig('broadcasting.pusher');

export default new Echo({
    broadcaster: 'pusher',
    key,
    cluster,
    namespace: 'App.Events',
    encrypted: true,
});
